"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.featuresList = void 0;
exports.featuresList = {
    "UserRegistration": "authentication.register",
    "UserRemoteRegistration": "authentication.register",
    "topBarHelp": "topBarLinks.help",
    "symbols": "symbols",
    "plans": "plans",
    "squid": "squid",
    "squidSwapping": "squid.swappingSymbols",
};
